const resources = {
    inStoreShopping: 'Magasinage en magasin',
    inStorePickup: 'Ramassage en magasin',
    curbside: 'Ramassage à l’extérieur',
    freeSamples: 'Essai d’essentiel gratuit',
    beautyServices: 'Services beauté',
    storeEvents: 'Événements en magasin'
};

export default function getResource(label) {
    return resources[label];
}
